/** @jsx jsx */
import { Spacer } from "@cd2/components"
import { P } from "@cd2/text/build/es6"
import { IComponentProp } from "@cd2/tools/build/es6"
import { css, jsx } from "@emotion/core"
import React from "react"
import { formattedRecordName } from "../../constants/humanisedRecordNames"

import { FileboyImageOrLocalBackgroundImage } from "../../interfaceParts/FileboyImageOrLocal"
import { TextGroupWithActions } from "../../interfaceParts/Title"
import { IRecordType } from "../../types/schema"

interface IProps {
  recordType?: IRecordType
  actions?: IComponentProp<typeof TextGroupWithActions, "actions">
  body?: React.ReactNode
  light?: boolean
}
export function PageNotFoundPage({ recordType, actions, light, body }: IProps) {
  if (window.location.pathname !== "/" && window.location.search.includes("did-switch-company")) {
    window.location.href = "/"
  }
  return (
    <div
      css={css`
        text-align: center;
        max-width: 500px;
        margin: 0 auto;
        padding: 32px 32px 200px;
      `}
    >
      <FileboyImageOrLocalBackgroundImage
        image={"squid"}
        css={css`
          height: 280px;
        `}
        contain
      />
      <Spacer />
      <TextGroupWithActions
        heading={`${recordType ? formattedRecordName(recordType) : "Page"} not found`}
        body={
          <React.Fragment>
            <P>
              {recordType
                ? "This record seems to have been moved or removed"
                : "There's nothing here"}
              ... please go back and try again
            </P>
            {body}
          </React.Fragment>
        }
        size={"large"}
        actions={[
          {
            children: "To the Dashboard",
            to: "/",
            leftIcon: "arrow-left",
            buttonStyle: light ? "solid" : "outline",
            buttonColor: light ? "white" : undefined,
          } as any,
          ...(actions ?? []),
        ]}
        theme={{ textBlock: { align: "center" as const } }}
      />
    </div>
  )
}
